import { useState, useCallback } from 'react';
import { goApi } from './apiService';

export const usePresignedUrl = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getPresignedUrl = useCallback(
        async (type: string, fileName: string, fileTypeId?: string): Promise<any | null> => {
            setLoading(true);
            setError(null);
            try {
                const res = await goApi.post<any>('/let-me-upload', {
                    fileType: type,
                    fileName: fileName,
                    fileTypeId: fileTypeId || '',
                });

                return res?.data;
            } catch (err: any) {
                setError(err?.message || 'Failed to get presigned URL');
                return null;
            } finally {
                setLoading(false);
            }
        },
        [],
    );

    return {
        loading,
        error,
        getPresignedUrl,
    };
};
